/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import React from 'react';
import { IHosportsFullWidthImageViewProps } from '../../../modules/hosports-full-width-image/./hosports-full-width-image';
import ScrollFadeIn from './../../../baseComponents/scroll-fade/./scroll-fade';
// @ts-ignore
import {MobileBreakpoint} from './../utilities/constants';

interface IState {
  image?:any;
}

class HosportsFullWidthImage extends React.Component<IHosportsFullWidthImageViewProps,IState> {

  public state: IState;

  constructor(props: IHosportsFullWidthImageViewProps) {
    super(props);
    this.state = {
      image:null
    };
  }
  public componentDidMount = () =>{
    const { config } = this.props;
    const image = ((window.innerWidth < MobileBreakpoint) && config.mobileImage) ? config.mobileImage : config.image;
    this.setState({
      image:image
    })
  }
  public render(): JSX.Element {
    if(!this.state.image) return <span />
    return (
      <ScrollFadeIn>
        <img className="full-width" src={this.state.image.src} />
      </ScrollFadeIn>
    );
  }
}

export default HosportsFullWidthImage;
